<div class="quiz-container">
  <div class="progress-bar">
    <div class="progress-thumb" [style.width.%]="100 * (currentIndex + 1) / stepsCount"></div>
  </div>
  <div class="quiz-step">
    <div class="icon" *ngIf="data.topIcon">{{ data.topIcon }}</div>
    <h3 [innerHTML]="data.title"></h3>

    <div class="subtitle" 
      *ngIf="data.subtitle && !(data.isVoting || data.rive || data.videoFilePath || data.imageFilePath || data.fullScreenImageFilePath || data.headline)"
      [innerHTML]="data.subtitle"
    ></div>

    <div 
      *ngIf="data.options || data.headline || data.rive || data.videoFilePath || data.imageFilePath || data.fullScreenImageFilePath || data.audioTracks || data.hasSocialProof || data.userReview" 
      class="content-container d-flex flex-column mt-20"
      [class.justify-content-end]="data.fullScreenImageFilePath"
    >
      <canvas
      #animation
      class="animation"
      width="1024"
      [height]="1024 / (data.rive?.ratio || 1)"
      [ngClass]="{ 'd-none': !data.rive }"
      [ngStyle]="{ 'background-image': getBackgroundImageUrl(), 'margin-top': data.rive?.marginTop }"
    ></canvas>

    <video
      *ngIf="data.videoFilePath"
      class="video"
      [src]="data.videoFilePath + '#t=0.1'"
      type="video/mp4"
      autoplay
      muted
      playsinline
    ></video>

    <div *ngIf="data.imageFilePath" class="image" [ngStyle]="{ 'background-image': getBackgroundImageUrl() }"></div>

    <h1 *ngIf="data.headline" class="display-1 headline" [class.negative]="data.isNegative">{{ data.headline }}</h1>

    <ng-container *ngIf="data.audioTracks">
      <app-audio-track
        *ngFor="let track of data.audioTracks"
        #audioTrackRef
        [data]="track"
        (onPlayed)="onPlay($event, track)"
      ></app-audio-track>
    </ng-container>

      <form [formGroup]="form">
        <ng-container *ngIf="data.options && !data.isChips">
          <!-- Multiple selection list -->
          <mat-selection-list
            *ngIf="data.isMultiple"
            [ngClass]="{
              'grid-list-odd': data.options.length % 2,
              'grid-list': data.isTilesDisplay
            }"
            [multiple]="true"
            formControlName="selectedOptions"
            [disableRipple]="true"
            (selectionChange)="optionClicked()"
          >
            <mat-list-option *ngFor="let option of data.options" [value]="option.title" [class]="option.imageMode || ''">
              <app-quiz-list-option [option]="option" [ngClass]="{
                'd-flex': option.imageMode === 'top' || option.imageMode === 'right',
                'flex-column': option.imageMode === 'top'
              }"></app-quiz-list-option>
            </mat-list-option>
          </mat-selection-list>

          <!-- Single selection list -->
          <mat-selection-list
            *ngIf="!data.isMultiple"
            [ngClass]="{
              'grid-list-odd': data.options.length % 2,
              'grid-list': data.isTilesDisplay
            }"
            [multiple]="false"
            formControlName="selectedOptions"
            [disableRipple]="true"
            (selectionChange)="optionClicked()"
          >
            <mat-list-option *ngFor="let option of data.options" [value]="option.title" [class]="option.imageMode || ''">
              <app-quiz-list-option [option]="option" [ngClass]="{
                'd-flex': option.imageMode === 'top' || option.imageMode === 'right',
                'flex-column': option.imageMode === 'top'
              }"></app-quiz-list-option>
            </mat-list-option>
          </mat-selection-list>
        </ng-container>

        <ng-container *ngIf="data.options && data.isChips">
          <mat-chip-listbox
            formControlName="selectedOptions"
            [multiple]="true"
            aria-label="Options selection"
          >
            <mat-chip-option *ngFor="let option of data.options" [value]="option.title">
              {{ option.title }}
            </mat-chip-option>
          </mat-chip-listbox>
        </ng-container>
      </form>

      <div 
        *ngIf="data.subtitle && (data.isVoting || data.rive || data.videoFilePath || data.imageFilePath || data.fullScreenImageFilePath || data.headline)" 
        class="subtitle bottom"
        [innerHTML]="data.subtitle"
      ></div>

      <div *ngIf="data.hasSocialProof" class="social-proof d-flex justify-content-space-between w-100">
        <div class="d-flex flex-column gap-5 text-start">
            <span>Average Score</span>
            <span class="review-stars">●●●●◐</span>
            <i class="fa-solid fa-star-half"></i>
        </div>
        <div class="d-flex flex-column gap-5 text-end">
            <span>Based On</span>
            <div class="harvard-image"></div>
        </div>
    </div>

      <app-user-review
        *ngIf="data.userReview"
        [data]="data.userReview"
      ></app-user-review>
    </div>
  </div>

  <div *ngIf="(!data.options || data.isChips || data.isMultiple) && !data.isVoting" class="quiz-footer gradient d-flex justify-content-center">
    <button mat-flat-button color="tagus" [disabled]="data.isRequired && (!form.value.selectedOptions || form.value.selectedOptions.length === 0)" (click)="buttonClicked()">
      Continue
    </button>
  </div>

  <div *ngIf="data.isVoting" class="quiz-footer d-flex justify-content-center align-items-center gap-10">
    <button class="voting-button" (click)="voteClicked('no')">No</button>
    <button class="voting-button" (click)="voteClicked('miss')">Not Sure</button>
    <button class="voting-button" (click)="voteClicked('yes')">Yes</button>
  </div>
</div>
